import React from "react";

/**
 * Inline SVG of the UpTick mark — small, scales cleanly in the Navbar.
 * Matches the brand asset: green circular badge, dashed white inner ring,
 * up-right arrow with the "U" letter sitting on the chart line.
 */
export default function UpTickMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="UpTick"
      className={className}
    >
      {/* outer mint ring */}
      <circle cx="32" cy="32" r="28" stroke="#2EA44F" strokeWidth="3.5" fill="none" />
      {/* inner dashed white ring */}
      <circle cx="32" cy="32" r="23" stroke="#E6EDF3" strokeWidth="1.2" strokeDasharray="2 2.4" fill="none" />
      {/* chart line dip → rise */}
      <path
        d="M 14 36 L 22 44 L 32 32 L 46 14"
        stroke="#E6EDF3"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* arrow head */}
      <path d="M 46 14 L 39 16 L 44 21 Z" fill="#2EA44F" />
      <path d="M 32 32 L 46 14" stroke="#2EA44F" strokeWidth="3" strokeLinecap="round" />
      {/* center white disc */}
      <circle cx="32" cy="32" r="7" fill="#E6EDF3" />
      {/* letter U */}
      <path
        d="M 28.5 28 L 28.5 33.5 A 3.5 3.5 0 0 0 35.5 33.5 L 35.5 28"
        stroke="#2EA44F"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
